import { render, staticRenderFns } from "./PeopleFormEditor.vue?vue&type=template&id=4cdf5cd3&scoped=true"
import script from "./PeopleFormEditor.vue?vue&type=script&lang=js"
export * from "./PeopleFormEditor.vue?vue&type=script&lang=js"
import style0 from "./PeopleFormEditor.vue?vue&type=style&index=0&id=4cdf5cd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdf5cd3",
  null
  
)

export default component.exports